import type { ReactNode } from "react";

export interface PanelHeaderProps {
  title: string;
  children: ReactNode;
}

export const PanelHeader = ({
  title,
  children,
}: Readonly<PanelHeaderProps>) => {
  return (
    <div className="flex w-full flex-row items-center justify-between border-b border-gray-300 select-none">
      <h2 className="text-md mr-4 min-w-0 flex-shrink truncate pl-3 font-semibold">
        {title}
      </h2>
      <div className="flex flex-shrink-0 items-center space-x-2 p-2">
        {children}
      </div>
    </div>
  );
};
